import * as yup from "yup";

const addInvoiceValidationSchema = yup.object({
  poNumber: yup
    .string("Enter Purchase Order")
    .required("Purchase Order is required"),
  billTo: yup.string("Enter Recipient Name").required("Recipient is required"),
  billToEmail: yup
    .string("Enter your email")
    .email("Enter a valid email")
    .required("Email is required"),
  billToPhone: yup.string().required("Phone Number is required"),
  billToCity: yup.string().nullable(),
  billToState: yup.string().nullable(),
  billToZip: yup.string().nullable(),
  paymentTerms: yup.string().nullable(),
  retentionPct: yup
    .number()
    .min(0, "Must be >= 0")
    .max(100, "Must be <= 100")
    .nullable(),
  invoiceDate: yup
    .date()
    .required("Invoice Date is required")
    .typeError("Enter a valid Invoice Date"),

  paymentDueDate: yup
    .date()
    .required("Payment Due Date is required")
    .typeError("Enter a valid Payment Due Date"),
  jobId: yup
    .string()
    .nullable()
    .when("clientType", {
      is: "contractor",
      then: (schema) =>
        schema.required("Job Id is mandatory for creating Invoice").min(1),
      otherwise: (schema) => schema.nullable(),
    }),
});

export const addInvoiceFields = [
  {
    key: "billTo",
    label: "Recipient Name",
    dynamicField: true,
    creatable: true,
    placeholder: "Recipient Name",
    width: "100%",
    type: "select",
    select: true,
    options: [],
    required: true,
  },
  {
    key: "billToEmail",
    label: "Send To Email Address",
    placeholder: "Enter Email Address",
    type: "text",
    width: "50%",
    required: true,
  },
  {
    key: "billToPhone",
    label: "Bill To Phone",
    placeholder: "Enter Phone",
    required: true,
    type: "text",
    width: "50%",
  },
  {
    key: "jobId",
    label: "Job",
    placeholder: "Select Job",
    type: "select",
    width: "50%",
    dynamicField: true,
  },
  {
    key: "poNumber",
    label: "PO Number",
    placeholder: "Enter Purchase Order",
    type: "text",
    required: true,
    width: "50%",
  },
  {
    key: "invoiceDate",
    placeholder: "MM/DD/YYYY",
    label: "Invoice Date",
    type: "dateField",
    width: "50%",
    required: true,
  },
  {
    key: "paymentDueDate",
    placeholder: "MM/DD/YYYY",
    label: "Payment Due Date",
    type: "dateField",
    width: "50%",
    required: true,
  },
  {
    key: "paymentTerms",
    label: "Payment Terms",
    placeholder: "Select Payment Terms",
    type: "text",
    select: true,
    options: ["Due on Receipt", "Net 15", "Net 30", "Net 45", "Net 60"],
    width: "50%",
  },
  {
    key: "retentionPct",
    label: "Retention %",
    placeholder: "0",
    type: "number",
    width: "50%",
  },
  // Bill To Address

  {
    key: "billToAddress",
    label: "Bill To Address ",
    placeholder: "Street, Apt, Suite, Unit (optional)",
    type: "text",
    width: "100%",
  },
  {
    key: "billToCity",
    label: "Bill To City",
    placeholder: "City",
    type: "text",
    width: "33%",
  },
  {
    key: "billToState",
    label: "Bill To State",
    placeholder: "State",
    type: "text",
    width: "33%",
  },
  {
    key: "billToZip",
    label: "Bill To ZIP",
    placeholder: "ZIP Code",
    type: "text",
    width: "33%",
  },
  {
    key: "notes",
    placeholder: "Enter Notes Max 500 Characters",
    label: "Notes",
    type: "textArea",
    extraInputProps: {
      multiline: true,
      className: "registration-formField task-notes property-details-textarea",
    },
    width: "100%",
  },
];

export const addInvoiceForm = {
  formFields: addInvoiceFields,
  validationSchema: addInvoiceValidationSchema,
  defaultState: (defaultState) => {
    if (defaultState) {
      return defaultState;
    }
    return Object.fromEntries(
      Object.keys(addInvoiceValidationSchema.fields).map((key) => [key, ""])
    );
  },
};

export const createFieldExtraProps = {
  billTo: {
    builder: () => ({
      optionKey: "userId",
      onChange: ({ field, value, inputValue, formik }) => {
        formik.setFieldValue(field.key, inputValue || value?.text || "");
        formik.setFieldValue(
          "billToEmail",
          value?.data?.email ? value.data.email : ""
        );
        formik.setFieldValue(
          "billToPhone",
          value?.data?.mobileNumber ? value.data.mobileNumber : ""
        );
        // formik.setFieldTouched("billToEmail", true);
        formik.setFieldValue("userId", value?.key || "");
      },
    }),
    supplier: () => ({}),
  },
  jobId: {
    builder: (formik) => ({
      onChange: (field, value) => {
        formik?.setFieldValue("jobId", value?.key || "");
        if (value?.data?.jobName) {
          formik?.setFieldValue("jobName", value?.data?.jobName);
        }
      },
    }),
    supplier: (formik) => ({
      optionKey: "jobId",
      required: true,
      onChange: (field, value) => {
        formik.setFieldValue("jobId", value?.key || "");
        if (value?.data?.jobName) {
          formik.setFieldValue("jobName", value.data.jobName);
        }
      },
    }),
  },
};
